import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function ImpersonateExchange() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [msg, setMsg] = useState("Entering project…");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setMsg("Missing handoff token."); return; }
    (async () => {
      try {
        const r = await api.post("/auth/impersonate-exchange", { token });
        setMsg(`Entering ${r.data?.project?.company_name || r.data?.project?.name || "project"}…`);
        try { await refresh?.(); } catch {}
        setTimeout(() => nav("/dashboard"), 400);
      } catch(e) {
        setMsg(e?.response?.data?.detail || "Handoff failed");
        toast.error(e?.response?.data?.detail || "Handoff failed");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="h-10 w-10 rounded-full border-4 border-primary/30 border-t-primary animate-spin mx-auto mb-4"/>
        <div className="text-lg font-heading">{msg}</div>
        <div className="text-xs text-muted-foreground mt-2">Super admin impersonation handoff</div>
      </div>
    </div>
  );
}
